import React from "react";

import { Alert, Box, Typography } from "@mui/material";
import { useRemoteField } from "@/hooks/useRemoteField";
import { ESRQuestionConfig } from "@/types/data";


export const ESRSummaryText = (props: ESRQuestionConfig) => {
    const { question_id, field_options, staticValue } = props;

    const [value] =
        staticValue != null
            ? [staticValue]
            : useRemoteField(
                  question_id,
                  field_options.length > 0 ? field_options[0] : ""
              );

    if (!value) return null;

    let summary: Record<string, string> = {};

    try {
        // Convert Python-style dict string to valid JSON
        const jsonString = value.replace(/'/g, '"');
        summary = JSON.parse(jsonString);
    } catch {
        return (
            <Alert icon={false}>
                {value}
            </Alert>
        );
    }

    return (
        <Alert
            icon={false}
            sx={{
                mb: 2,
                borderRadius: 2,
                "& .MuiAlert-message": {
                    width: "100%",
                },
            }}
        >

            {Object.entries(summary).map(([key, status]) => (
                <Typography
                    key={key}
                    variant="body2"
                    sx={{
                        fontWeight: 500,
						color: "text.primary"
                    }}
                >
                    {key}: {""}
					<Box
						component="span"
						sx={{
							color:
								status === "Success"
								? "success.main"
								: status === "Failed"
								? "error.main"
								: "text.primary",
								fontWeight: 600,
						}}
						>
							{status}
					</Box>
                </Typography>
            ))}
        </Alert>
    );
};